module.exports = __webpack_public_path__ + "media/images/user/lp/recommend/female-8ed688b32c307b23599fc65a75afd0b3.png";